var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CommonDrop',{attrs:{"url":"/trade/agreement/list/code","autoDefault":false,"filterable":true,"remote":true,"valName":_vm.valName,"labelName":"code","disabled":_vm.disabled,"clearable":true,"size":_vm.size,"placeholder":_vm.placeholder},model:{value:(_vm.currentValue),callback:function ($$v) {_vm.currentValue=$$v},expression:"currentValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }